import React from "react";

import { Button, Column, Columns } from "@origin-digital/ods-core";

import { BUTTON_SALES, BUTTON_CP } from "src/consts";

import { IButtons } from "src/consts/interfaces";

export const Buttons: React.FC<IButtons> = ({
  buttonLabelCP,
  buttonLabelSales,
  handleSubmit,
  disableBookMyMove = false,
  disableCP = false,
}) => {
  return (
    <>
      <Columns collapseBelow="sm" space="medium">
        {buttonLabelSales ? (
          <Column width="content">
            <Button
              data-id="movers-widget-wp-button-sales"
              id="button-sales"
              disabled={disableBookMyMove}
              onClick={() => handleSubmit(BUTTON_SALES)}
            >
              {buttonLabelSales}
            </Button>
          </Column>
        ) : null}
        {buttonLabelCP ? (
          <Column width="content">
            <Button
              data-id="movers-widget-wp-button-cp"
              id="button-cp"
              disabled={disableCP}
              onClick={() => handleSubmit(BUTTON_CP)}
              variant={buttonLabelSales ? "outlined" : "contained"}
            >
              {buttonLabelCP}
            </Button>
          </Column>
        ) : null}
      </Columns>
    </>
  );
};
